
import UnitCategoryInList from "@/components/properties/property-list-page/UnitCategoryInList";
import router from "@/mixins/router";
import propertyFormat from "@/mixins/propertyFormat";

export default {
  name: "PropertyListWithUnitCategory",
  props: {
    propertiesList: {
      default: []
    },
  },
  components: {
    UnitCategoryInList
  },
  mixins: [
    router,
    propertyFormat,
  ],
  data() {
    return {
      isOpenGallery: false,
      propertyImages: [],
      propertyNameGallery: null,
      networkNameGallery: null
    }
  },
  methods: {
    isSingleUnit(property) {
        return property.unit_categories.length == 1;
    },
    singleRoute(id, query) {
      return this.localePath({
        name: "properties-id",
        params: { id },
        query
      });
    },
    openGallery(images, name, network) {
      this.isOpenGallery = true;
      this.propertyImages = images;
      this.propertyNameGallery = name;
      this.networkNameGallery = network;
    },
    unitHasData(unitCategory) {
      let unitData = []
      unitData.push(
        unitCategory.room_features_bathrooms,
        unitCategory.room_features_bedrooms,
        unitCategory.room_features_beds,
        unitCategory.room_features_size
      )

      return !unitData.every(element => element === null)
    },
  },
};
